// Strings locales del módulo M7 · Acceso programático (clients M2M). docs/08 Ola B.
export const clientsI18n = {
  title: "Clients",
  description: "Credenciales máquina-a-máquina (client_credentials) para servicios y gateways.",
  create: "Nuevo client",
  search: "Buscar por nombre",
  filterStatus: "Estado",
  filterAll: "Todos",
  columns: {
    name: "Nombre",
    clientId: "Client ID",
    scopes: "Scopes",
    status: "Estado",
    lastUsed: "Último uso",
  },
  status: { active: "Activo", disabled: "Deshabilitado" },
  never: "Nunca",
  noScopes: "Sin scopes",
  empty: {
    title: "Aún no hay clients",
    description: "Crea un client M2M para que un servicio obtenga tokens.",
    action: "Crear el primero",
  },
  createDrawer: {
    title: "Nuevo client",
    submit: "Crear client",
    domain: "Dominio",
    allDomains: "Todos los dominios (instancia)",
    domainHint:
      'Déjalo en "Todos los dominios" para un gateway/backend que opera sobre todos los tenants; elige uno para acotarlo a ese dominio.',
  },
  editDrawer: { title: "Editar client", submit: "Guardar cambios" },
  fields: {
    name: "Nombre",
    scopes: "Scopes",
    scopesHint: "Haz clic para ver todos; escribe para filtrar; selecciona uno o varios.",
    scopesPlaceholder: "Busca y selecciona scopes…",
    scopesNoMatch: "Sin scopes que coincidan",
    scopesLoading: "Cargando scopes…",
    status: "Estado",
  },
  validation: {
    domainRequired: "Selecciona un dominio.",
    nameRequired: "Escribe un nombre.",
  },
  actions: {
    label: "Acciones del client",
    edit: "Editar",
    rotate: "Rotar secret",
    delete: "Eliminar",
  },
  delete: {
    title: "Eliminar client",
    message: "El client dejará de poder obtener tokens. ¿Continuar?",
    confirm: "Eliminar",
  },
  secret: {
    title: "Credenciales del client",
    description: "Guarda el secret ahora: no se vuelve a mostrar.",
    clientId: "Client ID",
    clientSecret: "Client secret",
    copy: "Copiar secret",
    close: "Cerrar",
  },
} as const
